<header class="wb-coverage-header">

  <div class="max-size-wrapper">

    <div class="grid-x">
      <div class="cell shrink">
          <button
          class="wb-nav-button mdl-button mdl-js-button mdl-button--primary"
          (click)="goBackButton()"
          [disabled]="!isBackButtonEnabled()">
            <i class="material-icons" *ngIf="isBackButtonEnabled()">arrow_back</i>
          </button>
      </div>
      <div class="cell auto">

          Rate Tables
        <h2>{{title}}</h2>

      </div>
      <div class="cell shrink">
        <button
        class="wb-nav-button mdl-button mdl-js-button mdl-button--primary"
        (click)="gotoWBQuote()"
        [disabled]="_dataService.isFromBrokerMobileApp()">
          <i class="material-icons" *ngIf="!_dataService.isFromBrokerMobileApp()">close</i>
        </button>
      </div>
    </div>

    <div class="wb-coverage-progressbar">
      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>

    </div>
  </div>
</header>
